import React from 'react';

const NebulaTransactionsFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaTransactionsModalRegistry = {
    personalize_nebulaTransactionsId: NebulaTransactionsFormModal
};
export default nebulaTransactionsModalRegistry;
